module.exports = __webpack_public_path__ + "img/invest.5e2aa534.png";